import { spacing } from 'modules/metrics';
import styled from 'styled-components';

import { bgColor, textGray } from '../../modules/colors';

const fontSize = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 20,
};

export const Number = styled.div`
  ${(props) => props.size && `font-size: ${fontSize[props.size]}px;`}
  font-weight: 500;
`;

export const Wrapper = styled.span`
  border-radius: 4px;
  background-color: ${bgColor};
  color: ${textGray};
  padding: ${spacing.sm}px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  ${(props) =>
    props.shadow &&
    'box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);'}
  white-space: nowrap;

  > img {
    margin-right: ${spacing.md}px;
  }
`;
